import Divider from 'components/Divider';
import { SearchAddressBar } from 'components/SearchAddressBar/SearchAddressBar';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { GraniteInput } from 'components/V2/Input/GraniteInput';
import React, { useState } from 'react';
import { SiteAddress } from 'api/addresssearch/schema';

const LinkAccountForm = () => {
  const [addressValue, setAddressValue] = useState<
    SiteAddress & { street?: string | null | undefined }
  >();
  return (
    <div className="flex h-auto flex-col items-start justify-start rounded-lg bg-background-base-surface-2">
      <div className="w-full rounded-t-lg bg-background-base-surface-3 px-8 py-6">
        <p className="text-[28px] font-bold leading-[36px] text-content-base-default">
          Link an account
        </p>
      </div>
      <form className="w-full">
        <div className="flex w-full flex-col items-start justify-start gap-8 px-8 pb-12 pt-8">
          <SearchAddressBar
            onAddressSelected={setAddressValue}
            className="w-full"
            value={addressValue}
          />
          <Divider className="w-full" />
          <div className="flex w-full flex-col gap-4">
            <p className="text-xl font-bold text-white">Location details</p>
            <div className="flex justify-between gap-4">
              <GraniteInput label="Business name" className="w-full" />
              <GraniteInput
                label="Suite/unit/flr # (optional)"
                className="w-full"
              />
            </div>
          </div>
          <Divider className="w-full" />
          <div className="flex w-full flex-col gap-4">
            <p className="text-xl font-bold text-white">
              Local contact details
            </p>
            <div className="flex justify-between gap-4">
              <GraniteInput label="Name" className="w-full" />
              <GraniteInput label="Phone number" className="w-full" />
            </div>
          </div>
        </div>
        <div className="flex gap-5 px-8 pb-8">
          <GraniteButton size="large" variant="secondary">
            Back
          </GraniteButton>
          <GraniteButton size="large">Submit</GraniteButton>
        </div>
      </form>
    </div>
  );
};

export default LinkAccountForm;
